import React, { ReactElement } from 'react';
import { Button, Grid, Row, Stack } from 'rsuite';

export interface PageButtonsProps {
  onNext?: () => void;
  onBack?: () => void;
  showNext?: boolean;
  showBack?: boolean;
  next?: string;
  back?: string;
}

const PageButtons = ({
  onNext,
  onBack,
  next = 'CONTINUE',
  back = 'BACK',
  showNext,
  showBack,
}: PageButtonsProps): ReactElement => {
  return (
    <Grid fluid>
      <Row className="mv-24">
        <Stack
          role="cell"
          className="flow-page-layout-button-back-container"
          direction="row"
        >
          {showNext && (
            <Button
              className="btn-primary mv-4 mr-16"
              onClick={onNext}
              data-cy="next-button"
            >
              {next}
            </Button>
          )}
          {showBack && (
            <Button
              className="btn-tertiary mv-4"
              onClick={onBack}
              data-cy="back-button"
            >
              {back}
            </Button>
          )}
        </Stack>
      </Row>
    </Grid>
  );
};

export default PageButtons;
